import axios from '../axios'
import qs from 'qs';

/* 
 * 用户管理模块
 */

// 创建
export const add = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/user/add',
        method: 'post',
        data
    })
}
// 查询
export const list = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/user/list',
        method: 'post',
        data
    })
}
// 修改
export const update = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/user/update',
        method: 'post',
        data
    })
}
// 删除
export const del = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/kz/user/delete',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/user.js